<template>
  <img class="mb-4 mt-5" src="./../assets/logo.png" alt width="40%" height="100%">
</template>

<script>
/* eslint-disable */
export default {
  name: "MainPage"
};
</script>


</style>



// WEBPACK FOOTER //
// src/components/MainPage.vue